<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Kategorie produktów</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja kategorii</template>
          <template v-else>Dodawanie kategorii</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/kategorie')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            title="Dane ogólne"
            active>
            <h4 class="mb-3 pb-3 bordering-bottom">
              Dane ogólne
            </h4>
            <validation-observer
              ref="categories-form"
              tag="form">
              <d-row>
                <d-col>
                  <div class="form-group">
                    <label for="name">
                      Nazwa kategorii:
                    </label>
                    <validation-provider
                      rules="required"
                      name="name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.name" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
                <d-col>
                  <div class="form-group">
                    <label for="ordering">
                      Kolejność:
                    </label>
                    <validation-provider
                      rules="required|min_value:1"
                      name="ordering"
                      v-slot="{ errors }">
                      <d-input
                        type="number"
                        id="ordering"
                        :state="errors.length ? 'invalid' : null"
                        v-model="data.ordering" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>
            </validation-observer>
            <div
              v-if="!allDataLoaded"
              class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="load_error"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a
                href="javascript:window.location.reload();"
              class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'categories-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loaded_categories;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
  },
  data () {
    return {
      data: {
        id: 0,
        name: '',
        ordering: null
      },
      loaded: false,
      load_error: false,
      loaded_categories: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }

    this.loadAdditionalData();
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/categories/item/',
        instanceFields: ['name', 'ordering'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/categories/items',
        params: {
          pagination: false
        },
        loadedKey: 'loaded_categories',
        errorKey: 'load_error',
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['categories-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/categories/update/' + this.id : '/categories/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano kategorię',
        successText: 'Wybrana kategoria została zapisana',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja kategorii nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/kategorie');
        }
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name,
        ordering: this.data.ordering,
      };
    }
  }
};
</script>
